import { bootcampSplitApi } from './split.api'

interface ResponseBestAccuracy {
  accuracy: number
  submissionDate: Date
}

interface ResponseActivityAccuracy {
  accuracy: number
}

const GetAccuracy = bootcampSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBestAccuracy: builder.query<ResponseBestAccuracy, { path: string }>({
      query: (params) => ({
        url: 'v1/user-stats/rounds/bootcamp-activity-set-accuracy',
        method: 'GET',
        params,
      }),
      transformResponse: (response: ResponseBestAccuracy) => {
        return {
          submissionDate: response.submissionDate,
          accuracy: Math.floor(response.accuracy * 100),
        }
      },
      providesTags: ['BestAccuracy'],
    }),
    getActivitySetAccuracy: builder.query<ResponseActivityAccuracy, { path: string; retakeRound: number | string }>({
      query: (params) => ({
        url: 'v1/user-stats/rounds/bootcamp-activity-set-accuracy',
        method: 'GET',
        params,
      }),
      transformResponse: (response: ResponseActivityAccuracy) => {
        return {
          accuracy: Math.floor(response.accuracy * 100),
        }
      },
      providesTags: ['ActivitySetAccuracy'],
    }),
  }),
})

export const { useGetBestAccuracyQuery, useGetActivitySetAccuracyQuery } = GetAccuracy
